<div *ngFor="let column of columns; trackBy: trackByIndex;" [class]="'lm-undistributed-column'">
  <lm-element
      *ngIf="column"
      [layoutObject]="column"
      [layoutInfo]="layoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
  ></lm-element>
</div>
